/**
 * Tailwind grid-cols classes for a filter bar with `count` controls.
 * Shared by the real filters and their skeleton so both lay out identically.
 */
export function filtersGridClass(count: number): string {
  if (count <= 2) return 'grid-cols-1 md:grid-cols-2 w-full';
  if (count === 3) return 'grid-cols-1 md:grid-cols-3 w-full';
  if (count === 4) return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full';
  if (count === 5) return 'grid-cols-1 md:grid-cols-3 lg:grid-cols-5 w-full';
  return 'grid-cols-1 md:grid-cols-3 lg:grid-cols-6 w-full';
}
